import { UPDATE_SPECIFIC_LVZ_DATA, RESET_SPECIFIC_LVZ_DATA } from "./specificLvzDataReducer"

export const updateSpecificLvzData = (data) => ({
    type: UPDATE_SPECIFIC_LVZ_DATA,
    payload: data
})

export const resetSpecificLvzData = () => ({
    type: RESET_SPECIFIC_LVZ_DATA,
})